import OperationForm from "./OperationForm";
export default function Delivrance() {
  return <OperationForm type="DELIVRANCE" />;
}
